var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheckYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "023927EF-20E9-425D-8673-6DF5E3886E7A@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEA7-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mais-web-5",
    transform: "translate(-141.000000, -561.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(120.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox/Selected-Copy-2",
    transform: "translate(21.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    fill: "#FFD100",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7128166,5.3175 L8.44781663,12.6175 C8.13031663,13.06 7.47281663,13.06 7.15531663,12.6175 L4.03781663,8.2975 C3.94281663,8.165 4.03781663,7.98 4.20031663,7.98 L5.37281663,7.98 C5.62781663,7.98 5.87031663,8.1025 6.02031663,8.3125 L7.80031663,10.7825 L11.7303166,5.3325 C11.8803166,5.125 12.1203166,5 12.3778166,5 L13.5503166,5 C13.7128166,5 13.8078166,5.185 13.7128166,5.3175 Z",
    id: "Path",
    fill: "#282850"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckYellow);
export default __webpack_public_path__ + "static/media/success-check-yellow.c59093187e3689d5fe828d5b6220c05f.svg";
export { ForwardRef as ReactComponent };